import React, { useState, useEffect, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import RYDriverAppNew from "@/iphone/RYDriverApp";
import RYShipAppNew from "@/iphone/RYShipApp";
import RYCommandAppNew from "@/iphone/RYCommandApp";
import RYWebAppNew from "@/iphone/RYWebApp";

/* ===== Shared chrome ===== */
const apple = "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif";

export function AppHeader({ title, light = false, action, subtitle, sticky = true }) {
  return (
    <div
      style={{
        position: sticky ? "sticky" : "relative",
        top: 0,
        zIndex: 5,
        background: light ? "rgba(242,242,247,0.85)" : "rgba(0,0,0,0.7)",
        backdropFilter: "blur(20px)",
        padding: "8px 18px 12px",
        borderBottom: `0.5px solid ${light ? "rgba(0,0,0,0.12)" : "rgba(255,255,255,0.12)"}`,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <div
            style={{
              fontFamily: apple,
              fontSize: 26,
              fontWeight: 700,
              letterSpacing: -0.6,
              color: light ? "#000" : "white",
            }}
          >
            {title}
          </div>
          {subtitle && (
            <div style={{ fontSize: 12, color: light ? "#666" : "rgba(255,255,255,0.6)", marginTop: 2 }}>
              {subtitle}
            </div>
          )}
        </div>
        {action}
      </div>
    </div>
  );
}

/* ===================== RY SHIP ===================== */
export const RYShipApp = RYShipAppNew;

function DeprecatedRYShipApp() {
  const [step, setStep] = useState(0);
  const next = () => setStep((s) => Math.min(4, s + 1));
  const back = () => setStep((s) => Math.max(0, s - 1));

  return (
    <div style={{ height: "100%", background: "#0a0a0a", color: "white", fontFamily: apple, overflow: "hidden", display: "flex", flexDirection: "column" }}>
      {/* mini status bar spacer */}
      <div style={{ height: 54 }} />

      <div style={{ padding: "0 22px 14px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.55)", letterSpacing: 2, fontWeight: 600 }}>RY · XPRESS</div>
          <div style={{ fontSize: 22, fontWeight: 700, marginTop: 2, letterSpacing: -0.4 }}>Ship Freight</div>
        </div>
        <div style={{ width: 36, height: 36, borderRadius: "50%", background: "rgba(255,255,255,0.08)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>
          AC
        </div>
      </div>

      <div style={{ display: "flex", gap: 4, padding: "0 22px 14px" }}>
        {[0, 1, 2, 3, 4].map((i) => (
          <div key={i} style={{ flex: 1, height: 3, borderRadius: 2, background: i <= step ? "#ff6b00" : "rgba(255,255,255,0.12)" }} />
        ))}
      </div>

      <div style={{ flex: 1, overflow: "auto", padding: "4px 22px 100px" }}>
        {step === 0 && <ShipStep0 />}
        {step === 1 && <ShipStep1 />}
        {step === 2 && <ShipStep2 />}
        {step === 3 && <ShipStep3 />}
        {step === 4 && <ShipStep4 />}
      </div>

      <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, padding: "12px 22px 32px", background: "linear-gradient(to top, #0a0a0a 60%, transparent)", display: "flex", gap: 10 }}>
        {step > 0 && (
          <button onClick={back} style={btnSecondary}>Back</button>
        )}
        <button onClick={step === 4 ? () => setStep(0) : next} style={{ ...btnPrimary, background: step === 4 ? "#10b981" : "#ff6b00" }}>
          {step === 0 && "Get Quote"}
          {step === 1 && "Accept · Continue"}
          {step === 2 && "Authorize Hold"}
          {step === 3 && "Track Load"}
          {step === 4 && "Book Another"}
        </button>
      </div>
    </div>
  );
}

const btnPrimary = {
  flex: 1,
  background: "#ff6b00",
  color: "white",
  border: "none",
  padding: "14px 16px",
  borderRadius: 14,
  fontSize: 15,
  fontWeight: 600,
  fontFamily: apple,
  cursor: "pointer",
};
const btnSecondary = {
  background: "rgba(255,255,255,0.08)",
  color: "white",
  border: "none",
  padding: "14px 18px",
  borderRadius: 14,
  fontSize: 15,
  fontWeight: 600,
  fontFamily: apple,
  cursor: "pointer",
};

function FieldCard({ label, value, accent }) {
  return (
    <div style={{ background: "rgba(255,255,255,0.04)", border: "0.5px solid rgba(255,255,255,0.08)", borderRadius: 14, padding: 14, marginBottom: 10 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, color: "rgba(255,255,255,0.55)", fontSize: 10, letterSpacing: 1.6, fontWeight: 600 }}>
        {accent && <span style={{ width: 6, height: 6, borderRadius: "50%", background: accent }} />}
        {label}
      </div>
      <div style={{ fontSize: 15, marginTop: 4, fontWeight: 500 }}>{value}</div>
    </div>
  );
}

function ShipStep0() {
  return (
    <>
      <FieldCard label="PICKUP" value="Toronto, ON · M5V 3A8" accent="#10b981" />
      <FieldCard label="DROP-OFF" value="Dallas, TX · 75201" accent="#ff6b00" />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 4 }}>
        <FieldCard label="WEIGHT" value="42,000 lb" />
        <FieldCard label="TRAILER" value="Dry Van 53'" />
      </div>
      <FieldCard label="PICKUP WINDOW" value="Tue Jun 24 · 08:00–11:00" />
    </>
  );
}

function ShipStep1() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#ff6b00", fontSize: 11, letterSpacing: 2, fontWeight: 600 }}>
        ✦ AI INSTANT QUOTE
      </div>
      <div style={{ fontSize: 56, fontWeight: 800, letterSpacing: -2, marginTop: 6 }}>$4,000</div>
      <div style={{ fontSize: 12, color: "rgba(255,255,255,0.55)", letterSpacing: 1, marginTop: -4 }}>CONFIDENCE 94% · ETA 38h</div>

      <div style={{ background: "rgba(255,255,255,0.04)", borderRadius: 14, padding: 14, marginTop: 18 }}>
        {[["Base lane rate", "$2,840"], ["Fuel surcharge", "$610"], ["Trailer (Dry Van)", "$320"], ["Demand × 1.06", "$230"]].map(([l, v]) => (
          <div key={l} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: 13 }}>
            <span style={{ color: "rgba(255,255,255,0.6)" }}>{l}</span>
            <span style={{ fontWeight: 500 }}>{v}</span>
          </div>
        ))}
        <div style={{ height: 0.5, background: "rgba(255,255,255,0.1)", margin: "8px 0" }} />
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, fontWeight: 700 }}>
          <span>Total</span><span style={{ color: "#ff6b00" }}>$4,000</span>
        </div>
      </div>
    </>
  );
}

function ShipStep2() {
  return (
    <>
      <div style={{ background: "linear-gradient(135deg, #2a2a2c, #1a1a1c)", borderRadius: 18, padding: 18, position: "relative", overflow: "hidden" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div style={{ fontSize: 10, letterSpacing: 2, color: "rgba(255,255,255,0.6)" }}>VISA · CREDIT</div>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#ff6b00", letterSpacing: 2 }}>RY · PAY</div>
        </div>
        <div style={{ fontSize: 18, letterSpacing: 4, marginTop: 38, fontFamily: "monospace" }}>•••• •••• •••• 4148</div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 14, fontSize: 11, color: "rgba(255,255,255,0.5)" }}>
          <span>ACME MANUFACTURING</span><span>09/28</span>
        </div>
      </div>
      <div style={{ marginTop: 16, padding: 14, background: "rgba(16,185,129,0.08)", border: "0.5px solid rgba(16,185,129,0.3)", borderRadius: 14 }}>
        <div style={{ fontSize: 10, letterSpacing: 1.5, color: "#10b981", fontWeight: 600 }}>ESCROW HOLD</div>
        <div style={{ fontSize: 28, fontWeight: 700, marginTop: 2 }}>$4,000.00</div>
        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.55)", marginTop: 4 }}>Released to driver on POD upload</div>
      </div>
    </>
  );
}

function ShipStep3() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: 10, color: "#10b981", fontSize: 11, letterSpacing: 2, fontWeight: 600 }}>
        <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#10b981" }} /> DRIVER ASSIGNED
      </div>
      <div style={{ background: "rgba(255,255,255,0.04)", borderRadius: 14, padding: 14, marginTop: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 52, height: 52, borderRadius: "50%", background: "linear-gradient(135deg, #ff6b00, #ff9c5b)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, fontWeight: 700 }}>MT</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 15, fontWeight: 600 }}>Dwayne Johnson</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.55)" }}>4.96 ★ · 12y · 1.4M mi · 99.2% OTD</div>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.55)", marginTop: 2 }}>2022 Kenworth T680 · Dry Van 53&apos;</div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: 14, padding: 14, background: "rgba(255,107,0,0.08)", border: "0.5px solid rgba(255,107,0,0.3)", borderRadius: 14, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontSize: 10, letterSpacing: 1.5, color: "rgba(255,255,255,0.6)" }}>WINNING BID</div>
          <div style={{ fontSize: 22, fontWeight: 700 }}>$2,940</div>
        </div>
        <div style={{ textAlign: "right", fontSize: 11, color: "rgba(255,255,255,0.5)" }}>
          ceiling $3,200<br/>RY margin <span style={{ color: "#10b981" }}>$1,060</span>
        </div>
      </div>
    </>
  );
}

function ShipStep4() {
  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: 24 }}>
        <div style={{ width: 76, height: 76, borderRadius: "50%", background: "rgba(16,185,129,0.15)", border: "2px solid #10b981", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="3" strokeLinecap="round">
            <path d="M5 12l5 5 9-11" />
          </svg>
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, marginTop: 14, letterSpacing: -0.4 }}>Delivered</div>
        <div style={{ fontSize: 12, color: "rgba(255,255,255,0.55)", marginTop: 2 }}>POD signed · 14:22 CT</div>
      </div>
      <div style={{ background: "rgba(255,255,255,0.04)", borderRadius: 14, padding: 14, marginTop: 22 }}>
        {[["Shipment", "#RY-48291"], ["Driver", "Dwayne J."], ["Total", "$4,000.00"], ["Transit", "37h 51m"]].map(([l, v]) => (
          <div key={l} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: 13 }}>
            <span style={{ color: "rgba(255,255,255,0.6)" }}>{l}</span>
            <span>{v}</span>
          </div>
        ))}
      </div>
    </>
  );
}

/* ===================== RY DRIVER (mvp full app) ===================== */
export const RYDriverApp = RYDriverAppNew;

function DeprecatedRYDriverApp() {
  const [tab, setTab] = useState("loads");
  const [openLoad, setOpenLoad] = useState(null);

  return (
    <div style={{ height: "100%", background: "#0a0a0a", color: "white", fontFamily: apple, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <div style={{ height: 54 }} />

      <div style={{ padding: "0 22px 12px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontSize: 11, color: "#ff6b00", letterSpacing: 2, fontWeight: 700 }}>RY DRIVER</div>
          <div style={{ fontSize: 22, fontWeight: 700, marginTop: 2, letterSpacing: -0.4 }}>Welcome, Dwayne</div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.55)" }}>Earnings · MTD</div>
          <div style={{ fontSize: 17, fontWeight: 700, color: "#10b981" }}>$14,820</div>
        </div>
      </div>

      <div style={{ display: "flex", gap: 6, padding: "0 22px 14px" }}>
        {[["loads", "Loads"], ["bids", "My Bids"], ["earnings", "Earnings"]].map(([id, lbl]) => (
          <button
            key={id}
            onClick={() => setTab(id)}
            style={{
              background: tab === id ? "#ff6b00" : "rgba(255,255,255,0.08)",
              color: "white",
              border: "none",
              padding: "8px 14px",
              borderRadius: 999,
              fontSize: 12,
              fontWeight: 600,
              fontFamily: apple,
              cursor: "pointer",
            }}
          >
            {lbl}
          </button>
        ))}
      </div>

      <div style={{ flex: 1, overflow: "auto", padding: "0 22px 30px" }}>
        {tab === "loads" && <DriverLoads onOpen={setOpenLoad} />}
        {tab === "bids" && <DriverBids />}
        {tab === "earnings" && <DriverEarnings />}
      </div>

      <AnimatePresence>
        {openLoad && <LoadSheet load={openLoad} onClose={() => setOpenLoad(null)} />}
      </AnimatePresence>
    </div>
  );
}

const driverLoads = [
  { id: "RY-48291", from: "Toronto, ON", to: "Dallas, TX", mi: 1389, ceiling: 3200, current: 2940, trailer: "Dry Van", weight: "42,000 lb", pickupIn: "Tomorrow · 08:00" },
  { id: "RY-48196", from: "Brampton, ON", to: "Chicago, IL", mi: 527, ceiling: 1640, current: 1540, trailer: "Reefer", weight: "28,400 lb", pickupIn: "Today · 18:00" },
  { id: "RY-48107", from: "Hamilton, ON", to: "Atlanta, GA", mi: 1015, ceiling: 2950, current: 2810, trailer: "Flatbed", weight: "39,200 lb", pickupIn: "Sat · 06:00" },
  { id: "RY-48088", from: "Mississauga, ON", to: "Memphis, TN", mi: 1142, ceiling: 2640, current: 2640, trailer: "Dry Van", weight: "33,000 lb", pickupIn: "Mon · 10:00" },
];

function DriverLoads({ onOpen }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {driverLoads.map((l) => (
        <motion.button
          key={l.id}
          whileTap={{ scale: 0.97 }}
          onClick={() => onOpen(l)}
          style={{
            background: "rgba(255,255,255,0.04)",
            border: "0.5px solid rgba(255,255,255,0.08)",
            borderRadius: 16,
            padding: 14,
            textAlign: "left",
            color: "white",
            cursor: "pointer",
            fontFamily: apple,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
            <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#10b981" }} />
            <span style={{ fontSize: 13, fontWeight: 600 }}>{l.from}</span>
            <span style={{ color: "rgba(255,255,255,0.4)" }}>→</span>
            <span style={{ fontSize: 13, fontWeight: 600 }}>{l.to}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.55)", letterSpacing: 0.5 }}>
              {l.mi.toLocaleString()} MI · {l.trailer} · {l.weight}
            </div>
            <div style={{ fontSize: 16, color: "#ff6b00", fontWeight: 700 }}>${l.current.toLocaleString()}</div>
          </div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", marginTop: 4 }}>Pickup: {l.pickupIn}</div>
        </motion.button>
      ))}
    </div>
  );
}

function LoadSheet({ load, onClose }) {
  const [bid, setBid] = useState(load.current - 60);
  return (
    <motion.div
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      exit={{ y: "100%" }}
      transition={{ type: "spring", damping: 30, stiffness: 280 }}
      style={{
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        top: 70,
        background: "rgba(20,20,22,0.96)",
        backdropFilter: "blur(40px)",
        borderTopLeftRadius: 28,
        borderTopRightRadius: 28,
        padding: 18,
        color: "white",
        fontFamily: apple,
        overflow: "auto",
      }}
    >
      <div style={{ width: 36, height: 4, background: "rgba(255,255,255,0.3)", borderRadius: 2, margin: "0 auto 14px" }} />
      <div style={{ fontSize: 11, letterSpacing: 2, color: "#ff6b00", fontWeight: 600 }}>LOAD {load.id}</div>
      <div style={{ fontSize: 22, fontWeight: 700, marginTop: 2, letterSpacing: -0.3 }}>{load.from} → {load.to}</div>
      <div style={{ fontSize: 12, color: "rgba(255,255,255,0.55)", marginTop: 4 }}>{load.trailer} · {load.weight} · {load.mi.toLocaleString()} mi</div>

      <div style={{ marginTop: 18, background: "rgba(255,255,255,0.04)", borderRadius: 14, padding: 14 }}>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12 }}>
          <span style={{ color: "rgba(255,255,255,0.55)" }}>Ceiling</span>
          <span style={{ fontWeight: 600 }}>${load.ceiling.toLocaleString()}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginTop: 4 }}>
          <span style={{ color: "rgba(255,255,255,0.55)" }}>Current low</span>
          <span style={{ fontWeight: 600, color: "#ff6b00" }}>${load.current.toLocaleString()}</span>
        </div>
      </div>

      <div style={{ marginTop: 14 }}>
        <div style={{ fontSize: 11, letterSpacing: 1.5, color: "rgba(255,255,255,0.55)", fontWeight: 600 }}>YOUR BID</div>
        <div style={{ fontSize: 38, fontWeight: 800, letterSpacing: -1, marginTop: 4 }}>${bid.toLocaleString()}</div>
        <input
          type="range"
          min={load.ceiling - 800}
          max={load.ceiling}
          value={bid}
          onChange={(e) => setBid(Number(e.target.value))}
          style={{ width: "100%", accentColor: "#ff6b00", marginTop: 8 }}
        />
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: "rgba(255,255,255,0.45)" }}>
          <span>floor ${(load.ceiling - 800).toLocaleString()}</span>
          <span>ceiling ${load.ceiling.toLocaleString()}</span>
        </div>
      </div>

      <div style={{ display: "flex", gap: 10, marginTop: 22 }}>
        <button onClick={onClose} style={btnSecondary}>Pass</button>
        <button onClick={onClose} style={btnPrimary}>Submit Bid</button>
      </div>
    </motion.div>
  );
}

function DriverBids() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {[
        { id: "RY-48107", lane: "HAM → ATL", bid: 2810, status: "LEADING", color: "#10b981" },
        { id: "RY-48088", lane: "MIS → MEM", bid: 2540, status: "OUTBID", color: "#ef4444" },
        { id: "RY-48022", lane: "WIN → DET", bid: 880, status: "WON · DELIVERED", color: "#10b981" },
      ].map((b) => (
        <div key={b.id} style={{ background: "rgba(255,255,255,0.04)", borderRadius: 14, padding: 12 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{b.lane}</div>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", marginTop: 2 }}>{b.id}</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: 15, fontWeight: 700 }}>${b.bid.toLocaleString()}</div>
              <div style={{ fontSize: 9, letterSpacing: 1.5, color: b.color, fontWeight: 600, marginTop: 2 }}>● {b.status}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function DriverEarnings() {
  const bars = [820, 1240, 980, 1640, 1410, 2110, 1820];
  const days = ["M", "T", "W", "T", "F", "S", "S"];
  return (
    <div>
      <div style={{ background: "linear-gradient(135deg, #1a1a1c, #0a0a0a)", borderRadius: 18, padding: 16, border: "0.5px solid rgba(255,107,0,0.3)" }}>
        <div style={{ fontSize: 10, letterSpacing: 2, color: "#ff6b00", fontWeight: 700 }}>NEXT PAYOUT · TOMORROW 06:00</div>
        <div style={{ fontSize: 40, fontWeight: 800, marginTop: 4 }}>$14,820</div>
        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.55)", marginTop: 2 }}>7 loads · same-day ACH +1.5%</div>
      </div>

      <div style={{ marginTop: 16, background: "rgba(255,255,255,0.04)", borderRadius: 16, padding: 14 }}>
        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.55)", letterSpacing: 1, fontWeight: 600 }}>THIS WEEK</div>
        <div style={{ display: "flex", alignItems: "flex-end", gap: 6, height: 110, marginTop: 10 }}>
          {bars.map((v, i) => (
            <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
              <div style={{ width: "100%", height: `${(v / 2200) * 100}%`, background: "linear-gradient(to top, #ff6b00, #ffa550)", borderRadius: 4 }} />
              <div style={{ fontSize: 10, color: "rgba(255,255,255,0.45)" }}>{days[i]}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ===================== RY COMMAND ===================== */
export const RYCommandApp = RYCommandAppNew;

function DeprecatedRYCommandApp() {
  const [tab, setTab] = useState("overview");

  return (
    <div style={{ height: "100%", background: "#0a0a0a", color: "white", fontFamily: apple, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <div style={{ height: 54 }} />

      <div style={{ padding: "0 22px 10px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 11, color: "#ff6b00", letterSpacing: 2, fontWeight: 700 }}>
          RY · COMMAND
          <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#10b981" }} />
          <span style={{ color: "rgba(255,255,255,0.55)", letterSpacing: 1 }}>LIVE</span>
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, marginTop: 2, letterSpacing: -0.4 }}>Operations</div>
      </div>

      <div style={{ display: "flex", gap: 6, padding: "0 22px 14px", overflowX: "auto" }} className="scrollbar-hide">
        {[["overview", "Overview"], ["loads", "Loads"], ["drivers", "Drivers"], ["revenue", "Revenue"]].map(([id, lbl]) => (
          <button
            key={id}
            onClick={() => setTab(id)}
            style={{
              background: tab === id ? "rgba(255,107,0,0.18)" : "rgba(255,255,255,0.06)",
              color: tab === id ? "#ff6b00" : "white",
              border: `0.5px solid ${tab === id ? "rgba(255,107,0,0.5)" : "rgba(255,255,255,0.08)"}`,
              padding: "7px 14px",
              borderRadius: 999,
              fontSize: 12,
              fontWeight: 600,
              fontFamily: apple,
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            {lbl}
          </button>
        ))}
      </div>

      <div style={{ flex: 1, overflow: "auto", padding: "0 22px 32px" }}>
        {tab === "overview" && <CommandOverview />}
        {tab === "loads" && <CommandLoads />}
        {tab === "drivers" && <CommandDrivers />}
        {tab === "revenue" && <CommandRevenue />}
      </div>
    </div>
  );
}

function KPI({ label, value, delta, neg }) {
  return (
    <div style={{ background: "rgba(255,255,255,0.04)", borderRadius: 14, padding: 12, flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: 9, letterSpacing: 1.5, color: "rgba(255,255,255,0.5)", fontWeight: 600 }}>{label}</div>
      <div style={{ fontSize: 18, fontWeight: 700, marginTop: 4, letterSpacing: -0.3 }}>{value}</div>
      <div style={{ fontSize: 10, color: neg ? "#ef4444" : "#10b981", marginTop: 2 }}>{neg ? "↓" : "↑"} {delta}</div>
    </div>
  );
}

function CommandOverview() {
  return (
    <>
      <div style={{ display: "flex", gap: 8 }}>
        <KPI label="ACTIVE LOADS" value="142" delta="+18" />
        <KPI label="REVENUE · MTD" value="$1.84M" delta="+12.4%" />
      </div>
      <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
        <KPI label="MARGIN" value="22.6%" delta="+1.3pt" />
        <KPI label="ON-TIME" value="98.1%" delta="+0.4pt" />
      </div>

      <div style={{ background: "rgba(255,255,255,0.04)", borderRadius: 16, padding: 14, marginTop: 14 }}>
        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.55)", letterSpacing: 1, fontWeight: 600 }}>REVENUE · 14D</div>
        <div style={{ fontSize: 22, fontWeight: 700, marginTop: 4 }}>$1,843,210</div>
        <div style={{ display: "flex", alignItems: "flex-end", gap: 3, marginTop: 10, height: 70 }}>
          {[42, 58, 51, 64, 72, 68, 78, 85, 91, 88, 96, 102, 118, 124].map((b, i) => (
            <div key={i} style={{ flex: 1, height: `${b * 0.6}%`, background: "linear-gradient(to top, #ff6b00, #ffa550)", borderRadius: 3 }} />
          ))}
        </div>
      </div>

      <div style={{ marginTop: 14, fontSize: 11, color: "rgba(255,255,255,0.55)", letterSpacing: 1, fontWeight: 600 }}>ALERTS</div>
      <div style={{ marginTop: 8, background: "rgba(239,68,68,0.08)", border: "0.5px solid rgba(239,68,68,0.3)", borderRadius: 12, padding: 12 }}>
        <div style={{ fontSize: 12, fontWeight: 600 }}>3 driver insurance policies expiring &lt; 14 days</div>
        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.55)", marginTop: 2 }}>Auto-reminder sent · review in Insurance tab</div>
      </div>
    </>
  );
}

function CommandLoads() {
  const rows = [
    { id: "RY-48291", lane: "TO → DAL", driver: "Dwayne J.", status: "IN TRANSIT", price: "$4,000", color: "#ff6b00" },
    { id: "RY-48196", lane: "BR → CHI", driver: "Lina K.", status: "BIDDING", price: "$1,940", color: "#3b82f6" },
    { id: "RY-48107", lane: "HA → ATL", driver: "Devon R.", status: "BOOKED", price: "$3,450", color: "#10b981" },
    { id: "RY-48088", lane: "MI → MEM", driver: "—", status: "QUOTED", price: "$2,640", color: "rgba(255,255,255,0.5)" },
    { id: "RY-48022", lane: "WI → DET", driver: "Dwayne J.", status: "DELIVERED", price: "$880", color: "#10b981" },
  ];
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {rows.map((r) => (
        <div key={r.id} style={{ background: "rgba(255,255,255,0.04)", borderRadius: 12, padding: 12 }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{r.lane}</div>
              <div style={{ fontSize: 10, color: "rgba(255,255,255,0.5)", marginTop: 2 }}>{r.id} · {r.driver}</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: 14, fontWeight: 700 }}>{r.price}</div>
              <div style={{ fontSize: 9, letterSpacing: 1.5, fontWeight: 600, color: r.color, marginTop: 2 }}>● {r.status}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function CommandDrivers() {
  const drivers = [
    { name: "Dwayne Johnson", rig: "Kenworth T680 · Dry Van", loads: 84, rating: 4.96 },
    { name: "Lina Kowalski", rig: "Volvo VNL · Reefer", loads: 62, rating: 4.91 },
    { name: "Devon Reyes", rig: "Peterbilt 579 · Flatbed", loads: 51, rating: 4.88 },
    { name: "Jess Patel", rig: "Freightliner · Dry Van", loads: 47, rating: 4.93 },
  ];
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {drivers.map((d) => (
        <div key={d.name} style={{ background: "rgba(255,255,255,0.04)", borderRadius: 12, padding: 12, display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 36, height: 36, borderRadius: "50%", background: "rgba(255,107,0,0.2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700 }}>
            {d.name.split(" ").map(p => p[0]).slice(0, 2).join("")}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 600 }}>{d.name}</div>
            <div style={{ fontSize: 10, color: "rgba(255,255,255,0.5)", marginTop: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{d.rig}</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 12, fontWeight: 600 }}>{d.loads} <span style={{ color: "rgba(255,255,255,0.5)", fontWeight: 400 }}>loads</span></div>
            <div style={{ fontSize: 11, color: "#ff6b00" }}>{d.rating} ★</div>
          </div>
        </div>
      ))}
    </div>
  );
}

function CommandRevenue() {
  return (
    <>
      <div style={{ display: "flex", gap: 8 }}>
        <KPI label="GROSS" value="$1.84M" delta="+12.4%" />
        <KPI label="MARGIN" value="$416K" delta="+9.1%" />
      </div>
      <div style={{ marginTop: 14, fontSize: 11, color: "rgba(255,255,255,0.55)", letterSpacing: 1, fontWeight: 600 }}>TOP LANES BY MARGIN</div>
      {[
        ["Toronto → Dallas", "$1,060", "26.5%"],
        ["Hamilton → Atlanta", "$910", "26.4%"],
        ["Mississauga → Houston", "$1,180", "24.5%"],
        ["London → Memphis", "$640", "22.1%"],
      ].map(([lane, margin, pct]) => (
        <div key={lane} style={{ background: "rgba(255,255,255,0.04)", borderRadius: 12, padding: 12, marginTop: 8, display: "flex", justifyContent: "space-between" }}>
          <span style={{ fontSize: 13 }}>{lane}</span>
          <div style={{ display: "flex", gap: 12 }}>
            <span style={{ color: "#10b981", fontSize: 13, fontWeight: 600 }}>{margin}</span>
            <span style={{ color: "#ff6b00", fontSize: 13, fontWeight: 600, width: 50, textAlign: "right" }}>{pct}</span>
          </div>
        </div>
      ))}
    </>
  );
}

/* ===================== CALCULATOR ===================== */
export function CalculatorApp() {
  const [display, setDisplay] = useState("0");
  const [prev, setPrev] = useState(null);
  const [op, setOp] = useState(null);
  const [reset, setReset] = useState(false);

  const press = (k) => {
    if (k === "AC") {
      setDisplay("0"); setPrev(null); setOp(null); setReset(false); return;
    }
    if (k === "±") { setDisplay((d) => d.startsWith("-") ? d.slice(1) : "-" + d); return; }
    if (k === "%") { setDisplay((d) => String(Number(d) / 100)); return; }
    if (k === ".") {
      if (reset) { setDisplay("0."); setReset(false); return; }
      if (!display.includes(".")) setDisplay(display + ".");
      return;
    }
    if (/[0-9]/.test(k)) {
      if (reset || display === "0") { setDisplay(k); setReset(false); }
      else setDisplay(display + k);
      return;
    }
    if (["+","-","×","÷"].includes(k)) {
      if (prev !== null && op && !reset) {
        const r = calc(prev, Number(display), op);
        setDisplay(fmt(r));
        setPrev(r);
      } else {
        setPrev(Number(display));
      }
      setOp(k); setReset(true); return;
    }
    if (k === "=") {
      if (op !== null && prev !== null) {
        const r = calc(prev, Number(display), op);
        setDisplay(fmt(r));
        setPrev(null); setOp(null); setReset(true);
      }
    }
  };
  const calc = (a, b, o) => o === "+" ? a + b : o === "-" ? a - b : o === "×" ? a * b : b === 0 ? 0 : a / b;
  const fmt = (n) => Number.isInteger(n) ? String(n) : String(parseFloat(n.toFixed(8)));

  const keys = [
    ["AC", "±", "%", "÷"],
    ["7", "8", "9", "×"],
    ["4", "5", "6", "-"],
    ["1", "2", "3", "+"],
    ["0", ".", "="],
  ];

  return (
    <div style={{ height: "100%", background: "#000", color: "white", fontFamily: apple, display: "flex", flexDirection: "column" }}>
      <div style={{ height: 54 }} />
      <div style={{ flex: 1, display: "flex", alignItems: "flex-end", justifyContent: "flex-end", padding: "0 22px 14px", fontSize: display.length > 8 ? 60 : 80, fontWeight: 300, letterSpacing: -2, wordBreak: "break-all", lineHeight: 1 }}>
        {display}
      </div>
      <div style={{ padding: "0 14px 26px", display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10 }}>
        {keys.flat().map((k, i) => {
          const isOp = ["÷", "×", "-", "+", "="].includes(k);
          const isFn = ["AC", "±", "%"].includes(k);
          const isZero = k === "0";
          const bg = isOp ? (op === k ? "white" : "#ff9500") : isFn ? "#a5a5a5" : "#333";
          const fg = isOp ? (op === k ? "#ff9500" : "white") : isFn ? "#000" : "white";
          return (
            <motion.button
              key={i}
              whileTap={{ scale: 0.92, opacity: 0.7 }}
              onClick={() => press(k)}
              style={{
                gridColumn: isZero ? "span 2" : "auto",
                background: bg,
                color: fg,
                border: "none",
                height: 64,
                borderRadius: 999,
                fontSize: 26,
                fontFamily: apple,
                fontWeight: 400,
                cursor: "pointer",
                textAlign: isZero ? "left" : "center",
                paddingLeft: isZero ? 26 : 0,
              }}
            >
              {k}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}

/* ===================== SETTINGS ===================== */
export function SettingsApp() {
  const sections = [
    [
      { ico: "✈️", label: "Airplane Mode", right: <Toggle defaultOn={false} /> },
      { ico: "📶", label: "Wi-Fi", right: <Right v="MeinHaus 5G" /> },
      { ico: "🅱", label: "Bluetooth", right: <Right v="On" /> },
    ],
    [
      { ico: "🔔", label: "Notifications", right: <Chev /> },
      { ico: "🔊", label: "Sounds & Haptics", right: <Chev /> },
      { ico: "🎯", label: "Focus", right: <Chev /> },
      { ico: "🌙", label: "Screen Time", right: <Chev /> },
    ],
    [
      { ico: "🛻", label: "RY Xpress", right: <Chev /> },
      { ico: "👤", label: "Account", right: <Chev /> },
    ],
  ];
  return (
    <div style={{ height: "100%", background: "#000", color: "white", fontFamily: apple, overflow: "auto" }}>
      <div style={{ height: 54 }} />
      <div style={{ padding: "0 18px 14px" }}>
        <div style={{ fontSize: 32, fontWeight: 700, letterSpacing: -0.6 }}>Settings</div>
      </div>
      {sections.map((sec, si) => (
        <div key={si} style={{ background: "#1c1c1e", borderRadius: 12, margin: "12px 18px" }}>
          {sec.map((row, ri) => (
            <div key={ri} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", borderBottom: ri < sec.length - 1 ? "0.5px solid rgba(255,255,255,0.08)" : "none" }}>
              <div style={{ width: 28, height: 28, borderRadius: 6, background: "rgba(255,255,255,0.08)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>{row.ico}</div>
              <div style={{ flex: 1, fontSize: 15 }}>{row.label}</div>
              {row.right}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
function Toggle({ defaultOn }) {
  const [on, setOn] = useState(defaultOn);
  return (
    <button onClick={() => setOn(!on)} style={{ background: on ? "#34c759" : "#39393d", width: 46, height: 28, borderRadius: 999, border: "none", padding: 2, cursor: "pointer", display: "flex", alignItems: "center" }}>
      <motion.div animate={{ x: on ? 18 : 0 }} transition={{ type: "spring", stiffness: 500, damping: 30 }} style={{ width: 24, height: 24, borderRadius: "50%", background: "white", boxShadow: "0 1px 3px rgba(0,0,0,0.3)" }} />
    </button>
  );
}
function Right({ v }) { return <div style={{ color: "rgba(255,255,255,0.5)", fontSize: 14 }}>{v} <Chev /></div>; }
function Chev() { return <span style={{ color: "rgba(255,255,255,0.3)", fontSize: 16, marginLeft: 4 }}>›</span>; }

/* ===================== CALENDAR ===================== */
export function CalendarApp() {
  const days = ["S", "M", "T", "W", "T", "F", "S"];
  const today = new Date();
  const month = today.toLocaleString("default", { month: "long" });
  const year = today.getFullYear();
  const first = new Date(today.getFullYear(), today.getMonth(), 1).getDay();
  const daysInMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
  const cells = [...Array(first).fill(null), ...Array.from({ length: daysInMonth }, (_, i) => i + 1)];
  return (
    <div style={{ height: "100%", background: "#000", color: "white", fontFamily: apple, overflow: "auto" }}>
      <div style={{ height: 54 }} />
      <div style={{ padding: "0 18px 16px" }}>
        <div style={{ fontSize: 13, color: "#ff453a", fontWeight: 600 }}>{today.toLocaleDateString("default", { weekday: "long" }).toUpperCase()}</div>
        <div style={{ fontSize: 32, fontWeight: 700, letterSpacing: -0.6, marginTop: 2 }}>{month} {today.getDate()}</div>
      </div>
      <div style={{ padding: "0 14px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 4, fontSize: 11, color: "rgba(255,255,255,0.5)", textAlign: "center", padding: "0 4px", marginBottom: 6 }}>
          {days.map((d, i) => <div key={i}>{d}</div>)}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 4 }}>
          {cells.map((d, i) => (
            <div key={i} style={{ aspectRatio: "1", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, color: d === today.getDate() ? "white" : "rgba(255,255,255,0.85)", background: d === today.getDate() ? "#ff453a" : "transparent", borderRadius: "50%" }}>
              {d ?? ""}
            </div>
          ))}
        </div>
      </div>
      <div style={{ padding: "20px 18px" }}>
        <div style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", fontWeight: 600, letterSpacing: 0.5 }}>{today.toLocaleDateString("default", { weekday: "long", month: "long", day: "numeric" })}</div>
        {[
          { time: "10:00 AM", title: "Standup", sub: "Eng team", color: "#ff453a" },
          { time: "2:30 PM", title: "Pitch review", sub: "RY Xpress proposal", color: "#ff6b00" },
          { time: "5:00 PM", title: "Demo run", sub: "Dwayne + Cameron", color: "#10b981" },
        ].map((e, i) => (
          <div key={i} style={{ display: "flex", gap: 12, padding: "10px 0", borderTop: "0.5px solid rgba(255,255,255,0.08)" }}>
            <div style={{ width: 3, background: e.color, borderRadius: 2 }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 600 }}>{e.title}</div>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.5)" }}>{e.sub}</div>
            </div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.55)" }}>{e.time}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ===================== WEATHER ===================== */
export function WeatherApp() {
  return (
    <div style={{ height: "100%", background: "linear-gradient(180deg, #4ba6ff 0%, #2563eb 60%, #1e3a8a 100%)", color: "white", fontFamily: apple, overflow: "auto", paddingBottom: 40 }}>
      <div style={{ height: 54 }} />
      <div style={{ textAlign: "center", paddingTop: 16 }}>
        <div style={{ fontSize: 26, fontWeight: 500 }}>Toronto</div>
        <div style={{ fontSize: 84, fontWeight: 200, letterSpacing: -3, lineHeight: 1, marginTop: 4 }}>72°</div>
        <div style={{ fontSize: 16, marginTop: 4 }}>Mostly Sunny</div>
        <div style={{ fontSize: 13, opacity: 0.85, marginTop: 2 }}>H:78°  L:64°</div>
      </div>
      <div style={{ margin: "26px 18px 0", padding: 14, background: "rgba(255,255,255,0.15)", backdropFilter: "blur(20px)", borderRadius: 18 }}>
        <div style={{ fontSize: 11, opacity: 0.85, letterSpacing: 0.5 }}>HOURLY FORECAST</div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 12 }}>
          {["Now","11","12","13","14","15","16"].map((t, i) => (
            <div key={t} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, fontSize: 13 }}>
              <div>{t}</div>
              <div style={{ fontSize: 22 }}>{i === 0 ? "☀️" : i < 3 ? "🌤" : "☁️"}</div>
              <div style={{ fontWeight: 500 }}>{72 + i * 1}°</div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ margin: "14px 18px 0", padding: 14, background: "rgba(255,255,255,0.15)", backdropFilter: "blur(20px)", borderRadius: 18 }}>
        <div style={{ fontSize: 11, opacity: 0.85, letterSpacing: 0.5 }}>10-DAY FORECAST</div>
        {["Today", "Sat", "Sun", "Mon", "Tue", "Wed"].map((d, i) => (
          <div key={d} style={{ display: "flex", alignItems: "center", padding: "8px 0", borderTop: i ? "0.5px solid rgba(255,255,255,0.2)" : "none" }}>
            <div style={{ width: 50, fontSize: 14, fontWeight: 500 }}>{d}</div>
            <div style={{ width: 30, fontSize: 18 }}>{["☀️","🌤","🌧","⛅","☀️","🌤"][i]}</div>
            <div style={{ flex: 1, height: 5, background: "rgba(255,255,255,0.15)", borderRadius: 3, margin: "0 14px", position: "relative" }}>
              <div style={{ position: "absolute", height: "100%", left: "20%", right: "20%", background: "linear-gradient(to right, #fcd34d, #f97316)", borderRadius: 3 }} />
            </div>
            <div style={{ fontSize: 14, width: 60, textAlign: "right", opacity: 0.7 }}>64° <span style={{ opacity: 0.6 }}>78°</span></div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ===================== CLOCK ===================== */
export function ClockApp() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const cities = [
    { name: "Cupertino", offset: -7 },
    { name: "London", offset: 1 },
    { name: "Tokyo", offset: 9 },
    { name: "Sydney", offset: 11 },
  ];
  return (
    <div style={{ height: "100%", background: "#000", color: "white", fontFamily: apple, overflow: "auto" }}>
      <div style={{ height: 54 }} />
      <div style={{ padding: "0 18px 14px" }}>
        <div style={{ fontSize: 32, fontWeight: 700, letterSpacing: -0.6 }}>World Clock</div>
      </div>
      {cities.map((c) => {
        const local = new Date(now.getTime() + (c.offset + now.getTimezoneOffset() / 60) * 3600000);
        const h = local.getHours();
        const m = local.getMinutes().toString().padStart(2, "0");
        return (
          <div key={c.name} style={{ padding: "14px 18px", borderTop: "0.5px solid rgba(255,255,255,0.08)" }}>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.55)" }}>{c.offset > 0 ? "+" : ""}{c.offset}HRS</div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontSize: 20, fontWeight: 500 }}>{c.name}</div>
              <div style={{ fontSize: 48, fontWeight: 200, letterSpacing: -2, fontVariantNumeric: "tabular-nums" }}>{h % 12 || 12}:{m}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

/* ===================== NOTES ===================== */
export function NotesApp() {
  const notes = [
    { t: "Pitch Notes - RY Xpress", d: "Friday", p: "Owner wants: dashboard + driver app + customer app. Bidding mechanic. 30% reusable from MeinHaus core." },
    { t: "Driver onboarding flow", d: "Yesterday", p: "Photo ID, CDL, MC#, insurance verify via FMCSA SAFER pull..." },
    { t: "AI pricing weights", d: "Wed", p: "Distance 28%, Fuel 22%, Broker history 18%, Trailer 12%, Demand 11%, Weight 9%" },
    { t: "Lane test - TO/DAL", d: "Tue", p: "$4,000 quote → $3,200 ceiling → $2,940 winning bid = $1,060 RY margin (26.5%)" },
    { t: "Demo script", d: "Mon", p: "Open with reverse-bid live waterfall. Then admin dashboard. Then 3 RY apps preview..." },
  ];
  return (
    <div style={{ height: "100%", background: "#000", color: "white", fontFamily: apple, overflow: "auto" }}>
      <div style={{ height: 54 }} />
      <div style={{ padding: "0 18px 6px" }}>
        <div style={{ fontSize: 32, fontWeight: 700, letterSpacing: -0.6 }}>Notes</div>
        <div style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", marginTop: 4 }}>{notes.length} notes</div>
      </div>
      <div style={{ padding: "10px 18px" }}>
        {notes.map((n, i) => (
          <div key={i} style={{ padding: "12px 0", borderTop: i ? "0.5px solid rgba(255,255,255,0.08)" : "none" }}>
            <div style={{ fontSize: 15, fontWeight: 600 }}>{n.t}</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.55)", marginTop: 4 }}>
              <span style={{ marginRight: 8 }}>{n.d}</span>
              <span style={{ opacity: 0.75 }}>{n.p}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ===================== PHOTOS ===================== */
export function PhotosApp() {
  const colors = ["#ff6b00", "#ec4899", "#3b82f6", "#10b981", "#f59e0b", "#8b5cf6", "#ef4444", "#06b6d4", "#84cc16"];
  const cells = Array.from({ length: 36 }, (_, i) => colors[i % colors.length]);
  return (
    <div style={{ height: "100%", background: "#000", color: "white", fontFamily: apple, overflow: "auto" }}>
      <div style={{ height: 54 }} />
      <div style={{ padding: "0 18px 12px" }}>
        <div style={{ fontSize: 32, fontWeight: 700, letterSpacing: -0.6 }}>Photos</div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 2, padding: "0 2px" }}>
        {cells.map((c, i) => (
          <div key={i} style={{ aspectRatio: "1", background: `linear-gradient(135deg, ${c}, ${c}aa)`, position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", inset: 0, background: `radial-gradient(circle at ${(i * 17) % 100}% ${(i * 23) % 100}%, rgba(255,255,255,0.4), transparent)` }} />
          </div>
        ))}
      </div>
    </div>
  );
}

/* ===================== Generic (fallback) ===================== */
export function GenericApp({ label }) {
  return (
    <div style={{ height: "100%", background: "#0a0a0a", color: "white", fontFamily: apple, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 30 }}>
      <div style={{ fontSize: 36, fontWeight: 700, letterSpacing: -0.6 }}>{label}</div>
      <div style={{ fontSize: 14, color: "rgba(255,255,255,0.5)", marginTop: 8, textAlign: "center" }}>
        This app is along for the ride.<br/>Built fresh in the next sprint.
      </div>
      <div style={{ marginTop: 30, padding: "8px 16px", borderRadius: 999, background: "rgba(255,255,255,0.08)", fontSize: 11, color: "rgba(255,255,255,0.55)", letterSpacing: 1 }}>
        SWIPE UP TO CLOSE
      </div>
    </div>
  );
}

/* ===================== App router ===================== */
export function getAppScreen(id, label) {
  switch (id) {
    case "ryship": return <RYShipApp />;
    case "rydriver": return <RYDriverApp />;
    case "rycommand": return <RYCommandApp />;
    case "ryweb": return <RYWebAppNew />;
    case "calculator": return <CalculatorApp />;
    case "settings": return <SettingsApp />;
    case "calendar": return <CalendarApp />;
    case "weather": return <WeatherApp />;
    case "clock": return <ClockApp />;
    case "notes": return <NotesApp />;
    case "photos": return <PhotosApp />;
    default: return <GenericApp label={label} />;
  }
}
